import React, {
    createContext,
    useState,
    useEffect
} from 'react';

const AuthContext = createContext();


export const AuthProvider = ({ children }) => {

    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const [user, setUser] = useState(null);

    const [loading, setLoading] = useState(true);


    // ==========================================
    // CHECK LOGIN WHEN APPLICATION STARTS
    // ==========================================
    useEffect(() => {

        const token = localStorage.getItem('token');

        const userId = localStorage.getItem('user_id');

        const name = localStorage.getItem('name');

        const email = localStorage.getItem('email');

        const userType = localStorage.getItem('user_type');


        // ==========================================
        // USER IS ALREADY LOGGED IN
        // ==========================================
        if (token) {

            setIsAuthenticated(true);

            setUser({
                user_id: userId,
                name: name,
                email: email,
                user_type: userType
            });

        } else {

            // ==========================================
            // USER IS NOT LOGGED IN
            // ==========================================
            setIsAuthenticated(false);

            setUser(null);

        }


        // Authentication check completed
        setLoading(false);

    }, []);


    // ==========================================
    // LOGIN
    // ==========================================
    const login = (
        user_id,
        token,
        name,
        email,
        user_type
    ) => {

        // ==========================================
        // SAVE USER DATA
        // ==========================================

        localStorage.setItem(
            'user_id',
            user_id
        );

        localStorage.setItem(
            'token',
            token
        );

        localStorage.setItem(
            'name',
            name
        );

        localStorage.setItem(
            'email',
            email
        );

        localStorage.setItem(
            'user_type',
            user_type
        );


        // ==========================================
        // UPDATE AUTH STATE
        // ==========================================

        setIsAuthenticated(true);

        setUser({
            user_id: user_id,
            name: name,
            email: email,
            user_type: user_type
        });

    };


    // ==========================================
    // LOGOUT
    // ==========================================
    const logout = () => {

        // Remove authentication information
        localStorage.removeItem('user_id');
        localStorage.removeItem('token');
        localStorage.removeItem('name');
        localStorage.removeItem('email');
        localStorage.removeItem('user_type');


        // Reset authentication state
        setIsAuthenticated(false);

        setUser(null);

    };


    // ==========================================
    // CONTEXT
    // ==========================================
    return (

        <AuthContext.Provider
            value={{
                isAuthenticated,
                user,
                login,
                logout,
                loading
            }}
        >

            {children}

        </AuthContext.Provider>

    );

};


export default AuthContext;